import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/landing/1.png'
import _imports_1 from '../assets/images/price/2.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"col-3 position-absolute top-0 end-0 z-index--200\"><div class=\"ratio ratio-1x1\"><img src=\"" + _imports_0 + "\" alt=\"symbol\"></div></div><div class=\"col-3 position-absolute bottom-0 start-0 z-index--200\"><div class=\"ratio ratio-1891x2633\"><img src=\"" + _imports_1 + "\" alt=\"symbol\"></div></div>", 2)
const _hoisted_3 = { class: "text-center position-relative" }
const _hoisted_4 = { class: "m-0 d-flex flex-column align-items-center justify-content-center vh-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "col-12 text-primary custom-font-size-title fw-bold" }, " ERROR 404 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "col-12 custom-font-size-subtitle" }, "Page Not Found.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "col-12 custom-font-size-description" }, " \"Sorry, the page you are looking for could not be found. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-home fa-5x",
  "aria-hidden": "true"
}, null, -1)

import { storeToRefs } from "pinia";
import { useClientStore } from "@/store/ClientStore";

const __default__ = {
  name: "ErrorPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { loggedIn } = storeToRefs(useClientStore());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_router_link, {
          to: { name: _unref(loggedIn) ? 'Projects' : 'SignIn' },
          class: "fw-bold d-block pt-3 text-success"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})